// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.empty-state {
  margin: 60px 0;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 72px;
}
.empty-state .illustration {
  max-width: 287px;
  margin-left: auto;
}
.empty-state .message {
  display: flex;
  flex-direction: column;
  justify-content: center;
  max-width: 270px;
}
.empty-state .message .title {
  margin-bottom: 16px;
}
.empty-state .message p {
  color: var(--gray_dark2);
}
.empty-state .message .pin-button {
  width: 20px;
  transform: translateY(4px);
}`, "",{"version":3,"sources":["webpack://./src/components/EmptyState/index.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,aAAA;EACA,qCAAA;EACA,cAAA;AACF;AACE;EACE,gBAAA;EACA,iBAAA;AACJ;AAEE;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,gBAAA;AAAJ;AAEI;EACE,mBAAA;AAAN;AAGI;EACE,wBAAA;AADN;AAII;EACE,WAAA;EACA,0BAAA;AAFN","sourcesContent":[".empty-state {\n  margin: 60px 0;\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  grid-gap: 72px;\n\n  .illustration {\n    max-width: 287px;\n    margin-left: auto;\n  }\n\n  .message {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    max-width: 270px;\n\n    .title {\n      margin-bottom: 16px;\n    }\n\n    p {\n      color: var(--gray_dark2);\n    }\n\n    .pin-button {\n      width: 20px;\n      transform: translateY(4px);\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
